import React, { Fragment } from 'react';
import FaqTextWithLink from './FaqTextWithLink';
import payment from '../../../../images/payment-methods.png';

const FaqTextContent = ({ content }) => {
  return content.map((info, index) => {
    // Plain Text
    if (info.pretext) {
      return <p key={info.pretext}>{info.pretext}</p>;
    }

    if (info.mixedPretext) {
      return (
        <div key={info.mixedPretext}>
          {info.mixedPretext.leadingPretext}
          <strong>{info.mixedPretext.boldPretext}</strong>
          {info.mixedPretext.postingPretext}
          {!info.mixedPretext.newline && <br />}
          {!info.mixedPretext.newline && <br />}
        </div>
      );
    }

    if (info.table) {
      return (
        <div>
          <table border="1" width="90%" height="120px">
            <tr>
              {info.table.title.map(title => (
                <th style={{ fontWeight: 'bold' }}>{title}</th>
              ))}
            </tr>
            <tr>
              {info.table.rowContent1.map(rowData => (
                <td>{rowData}</td>
              ))}
            </tr>
            <tr>
              {info.table.rowContent2.map(rowData => (
                <td>{rowData}</td>
              ))}
            </tr>
            <tr>
              {info.table.rowContent3.map(rowData => (
                <td>{rowData}</td>
              ))}
            </tr>
          </table>
          <br />
        </div>
      );
    }

    if (info.sublist) {
      return (
        <Fragment>
          <ul>
            {info.sublist.map(list =>
              list.map(item =>
                item.listtitle ? (
                  <li
                    key={item.listtitle}
                    style={{
                      listStyleType: 'decimal'
                    }}>
                    <strong>{item.listtitle.title} </strong>
                    <span style={{ fontWeight: 'normal' }}>
                      {item.listtitle.description}
                    </span>
                  </li>
                ) : (
                  <ul>
                    <li style={{ listStyleType: 'circle' }}>
                      <strong>{item.text.boldtext}</strong>
                      {item.text.plaintext}
                      {item.text.lowerSublist &&
                        item.text.lowerSublist.map(lowerItem => (
                          <li>{lowerItem.text}</li>
                        ))}
                    </li>
                  </ul>
                )
              )
            )}
          </ul>
          <br />
          {info.note && <strong>{info.note}</strong>}
        </Fragment>
      );
    }
    //list of text (bold words included)
    if (info.text) {
      if (Array.isArray(info.text)) {
        return (
          <ul>
            {info.text.map(t => (
              <li
                key={t}
                style={
                  t.contact
                    ? { listStyleType: 'none' }
                    : { listStyleType: 'decimal' }
                }>
                {t.link && <FaqTextWithLink link={t.link} />}
                <strong>{t.boldtext}</strong>
                {t.plaintext}
              </li>
            ))}
          </ul>
        );
      } else {
        return (
          <ul>
            <li
              key={info.text}
              style={
                info.text.tiltedtext
                  ? { listStyleType: 'circle' }
                  : { listStyleType: 'disc' }
              }>
              <strong>{info.text.boldtext}</strong>
              {info.text.plaintext}
              <i>{info.text.tiltedtext}</i>
              <ul>
                <li
                  style={
                    info.text.subtext
                      ? { listStyleType: 'lower-roman' }
                      : { listStyleType: 'none' }
                  }>
                  {info.text.subtext}
                </li>
              </ul>
            </li>
          </ul>
        );
      }
    }

    if (info.subtitle) {
      return <span style={{ fontWeight: 'bold' }}>{info.subtitle}</span>;
    }

    if (info.posttext) {
      return <p key={info.posttext}>{info.posttext}</p>;
    }
    // Text with link inside
    if (info.link) {
      return <FaqTextWithLink link={info.link} />;
    }

    if (info.img) {
      return (
        <img
          src={payment}
          style={window.innerWidth < 768 ? { width: '275px' } : null}
        />
      );
    }
    if (info.note) {
      return <strong>Note: {info.note}</strong>;
    }
  });
};

export default FaqTextContent;



// WEBPACK FOOTER //
// ./src/components/Static/SFFleets/Shared/FaqTextContent.js